export enum NarrativeConstants {
  NOT_IMPLEMENTED = 'narrative/NOT_IMPLEMENTED',
  SET_NARRATIVE_TEXT = 'narrative/SET_NARRATIVE_TEXT',
  SET_NARRATIVE_TEXT_PNNV = 'narrative/SET_NARRATIVE_TEXT_PNNV',
  SET_NARRATIVE_STATE = 'narrative/SET_NARRATIVE_STATE',
  SAVE_NARRATIVE = 'narrative/SAVE_NARRATIVE',
  SET_RESPONSE = 'narrative/SET_RESPONSE',
  RESET_STATE = 'narrative/RESET_STATE',
  SET_HPI = 'narrative/SET_HPI',
}
